import { render, staticRenderFns } from "./SitesOverviewPage.vue?vue&type=template&id=566210da&"
import script from "./SitesOverviewPage.vue?vue&type=script&lang=js&"
export * from "./SitesOverviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports